import react, {useEffect, useState} from 'react'
import {toast} from "react-hot-toast";
import {Toast} from "react-bootstrap";
import React from "react";

import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import {PUBLIC_URL} from "../utils/api";

export const FireBaseContext = React.createContext();

const FireBaseProvider = ({children}) => {

    const firebaseConfig = {
        apiKey: "AIzaSyCR1esQt2-y2fg9-2V1L1ChCizxduilc5A",
        authDomain: "rdcc-52a29.firebaseapp.com",
        projectId: "rdcc-52a29",
        storageBucket: "rdcc-52a29.appspot.com",
        messagingSenderId: "153079786673",
        appId: "1:153079786673:web:5ffb8f914139ab04978690",
        measurementId: "G-MGL2PM2RY0"
    };
    const app = initializeApp(firebaseConfig);
    const messaging = getMessaging(app);

    const registerFCMToken = (token) => {
        return token
    }

    const requestForToken = async () => {
        const swRegistration = await navigator.serviceWorker.register(`${process.env.PUBLIC_URL}/firebase-messaging-sw.js`);

        return getToken(messaging, {
            serviceWorkerRegistration: swRegistration,
            vapidKey: "BBoC7bloOsRmMPqIJShNhvoZ7IRgGerI04k-mjZAyg-BjBGs0zH1ODWSTdvYvK9bgazz8pgh12eTbWfVujZ-6Lk"
        })
        .then((currentToken) => {
            if (currentToken) {
                console.log("current token for client", currentToken)
                registerFCMToken(currentToken)
            }else {
                console.log("No registration token available")
            }
        })
    }

    const token = requestForToken()

    onMessage(messaging, (payload) => {
        toast.custom((t) => {
            var title = payload.notification.title
            var content = payload.notification.body

            if(payload.data.click_action) {
                content = (
                    <a href={payload.data.click_action} target={"_blank"} style={{textDecoration:"none", color:"inherit"}}>
                        {content}
                    </a>
                )
            }

            return (
                <Toast delay={0} onClose={() => toast.dismiss(t.id)}>
                    <Toast.Header>
                        <strong className="me-auto">{title}</strong>
                    </Toast.Header>
                    <Toast.Body>
                        {content}
                    </Toast.Body>
                </Toast>
            )
        }, { duration: 60000 })
    })

    return children

}

export default FireBaseProvider